import { z } from "zod";
import { ZDateish } from "./commonSchema";
const emptyStringToUndefined = (value) => {
    if (typeof value !== "string") {
        return value;
    }
    const trimmed = value.trim();
    return trimmed.length === 0 ? undefined : trimmed;
};
const ZOptionalString = z.preprocess(emptyStringToUndefined, z.string().optional());
export const ZMaconomyProject = z.object({
    projectNo: z.number(),
    jobNumber: z.string().min(1),
    name: z.string().min(1),
    description1: ZOptionalString,
    description2: ZOptionalString,
    description3: ZOptionalString,
    status: z.number().nullable().optional(),
    closed: z.number().nullable().optional(),
    jobState: z.number().nullable().optional(),
    changedDate: ZDateish.nullable().optional(),
    transactionTimestamp: ZDateish.optional(),
});
